import styled, { css } from "styled-components";

export const StyledAnimateSplitFadeIn = styled.div`
`;
